import s from "./SecurityNoticeBanner.module.css";

/** R-SEC-1 — deterministic parse; no external LLM / document-AI on upload content. */
export function SecurityNoticeBanner() {
  return (
    <div className={s.banner} role="note">
      Deterministic normalisation only — upload content is not sent to external
      LLMs or document-AI services.
    </div>
  );
}
